// Theme configurations matching the legacy project ERP styling
export const THEME = {
  bg: "#f5f7fa",
  bgCard: "#ffffff",
  bgLight: "#f8fafc",
  primary: "#6366f1", // Indigo
  success: "#10b981", // Emerald
  warning: "#f59e0b", // Amber
  danger: "#ef4444",  // Rose
  text: "#0f172a",
  textMuted: "#64748b",
  border: "#e2e8f0",
};

// Initial states for forms
export const INIT_CATEGORY_FORM = {
  video_category: "",
  estatus: 1, // Active by default
};

export const INIT_SUBCATEGORY_FORM = {
  video_sub_category: "",
  video_category_id: "",
  description: "",
  estatus: 1, // Active by default
};

export const INIT_LECTURE_FORM = {
  id: undefined,
  video_category_id: "",
  video_sub_category_id: "",
  paid_video: 0, // Free by default (0: Free, 1: Paid)
  lecturer_id: "",
  class_id: "",
  subject_id: "",
  title: "",
  description: "",
  video_url: "", // R2 Key or external URL
  publish: 1, // Publish immediately (1: Yes, 0: No)
  doc_file: "", // document attachment
  video_date: new Date().toLocaleDateString("en-CA"),
  estatus: 1,
};

// Mock data to ensure the UI renders correctly out-of-the-box prior to backend deployment
export const MOCK_CLASSES = [
  { id: "1", class: "Grade 6" },
  { id: "2", class: "Grade 7" },
  { id: "3", class: "Grade 8" },
  { id: "4", class: "Grade 9" },
  { id: "5", class: "Grade 10" },
  { id: "6", class: "Grade 11" },
  { id: "7", class: "Grade 12" },
];

export const MOCK_SUBJECTS = {
  "1": [
    { id: 101, subject: "Mathematics" },
    { id: 102, subject: "Science" },
    { id: 103, subject: "Social Studies" },
  ],
  "2": [
    { id: 201, subject: "Mathematics" },
    { id: 202, subject: "Science" },
    { id: 203, subject: "Social Studies" },
  ],
  "3": [
    { id: 301, subject: "Mathematics" },
    { id: 302, subject: "Science" },
    { id: 303, subject: "English" },
  ],
  "4": [
    { id: 401, subject: "Mathematics" },
    { id: 402, subject: "Physics" },
    { id: 403, subject: "Chemistry" },
    { id: 404, subject: "Biology" },
  ],
  "5": [
    { id: 501, subject: "Mathematics" },
    { id: 502, subject: "Physics" },
    { id: 503, subject: "Chemistry" },
    { id: 504, subject: "Biology" },
  ],
  "6": [
    { id: 601, subject: "Mathematics (Algebra & Calculus)" },
    { id: 602, subject: "Physics (Mechanics)" },
    { id: 603, subject: "Chemistry (Organic)" },
  ],
  "7": [
    { id: 701, subject: "Mathematics (Integration)" },
    { id: 702, subject: "Physics (Electromagnetism)" },
    { id: 703, subject: "Chemistry (Physical)" },
  ],
};

export const MOCK_LECTURERS = [
  { employeeId: "emp_101", employee_name: "Mrs. Priya Sharma" },
  { employeeId: "emp_102", employee_name: "Mr. Ravi Kumar" },
  { employeeId: "emp_103", employee_name: "Dr. Arjun Mehta" },
  { employeeId: "emp_104", employee_name: "Mrs. Sneha Rao" },
];

export const MOCK_BRANCHES = [
  { id: "1", branch_name: "Main Campus (Hyderabad)" },
  { id: "2", branch_name: "North Branch (Secunderabad)" },
  { id: "3", branch_name: "City Center (Gachibowli)" },
];

export const MOCK_CATEGORIES = [
  { id: 1, video_category: "Core Subjects", estatus: 1 },
  { id: 2, video_category: "Revision Lectures", estatus: 1 },
  { id: 3, video_category: "Special Seminars", estatus: 1 },
];

export const MOCK_SUBCATEGORIES = [
  { id: 11, video_sub_category: "Mathematics Basics", description: "Foundational mathematics tutorials", video_category_id: 1, estatus: 1 },
  { id: 12, video_sub_category: "Advanced Calculus", description: "Limits, Derivatives and Integrals lectures", video_category_id: 1, estatus: 1 },
  { id: 13, video_sub_category: "Organic Chemistry Revision", description: "Revision chapters for board exams", video_category_id: 2, estatus: 1 },
  { id: 14, video_sub_category: "Physics Mock Solves", description: "Solving previous year papers live", video_category_id: 2, estatus: 1 },
  { id: 15, video_sub_category: "Careers in STEM", description: "Special webinar with industry practitioners", video_category_id: 3, estatus: 1 },
];



export const MOCK_VIDEOS = [
  {
    id: 1,
    video_category_id: "1",
    video_sub_category_id: "12",
    paid_video: 0,
    lecturer_id: "emp_101",
    institute_id: 1,
    branch_ids: "1,2",
    class_id: "7",
    subject_id: 701,
    title: "Integration by Parts — ILATE Rule & Derivations",
    description: "In this lecture we cover the Integration by Parts technique with the ILATE rule, then solve five board-exam favourite examples.",
    video_url: "integration_by_parts_r2_key", // Simulated R2 Key
    publish: 1,
    doc_file: "ILATE_Cheat_Sheet.pdf",
    video_date: "2026-06-01",
    estatus: 1,
    inserted_by: 12,
    inserted_time: "2026-06-01T10:00:00Z",
    updated_by: 12,
    updated_time: "2026-06-01T10:00:00Z",
  },
  {
    id: 2,
    video_category_id: "1",
    video_sub_category_id: "11",
    paid_video: 1,
    lecturer_id: "emp_102",
    institute_id: 1,
    branch_ids: "1",
    class_id: "6",
    subject_id: 601,
    title: "Matrices — Basics of Algebra, Additions & Multiplications",
    description: "Detailed step by step introduction to Matrix Algebra for Grade 11. Learn properties of matrix multiplication.",
    video_url: "https://www.w3schools.com/html/mov_bbb.mp4", // Direct playback URL for demonstration fallback
    publish: 1,
    doc_file: "",
    video_date: "2026-06-02",
    estatus: 1,
    inserted_by: 12,
    inserted_time: "2026-06-02T11:00:00Z",
    updated_by: 12,
    updated_time: "2026-06-02T11:00:00Z",
  },
  {
    id: 3,
    video_category_id: "2",
    video_sub_category_id: "13",
    paid_video: 0,
    lecturer_id: "emp_103",
    institute_id: 1,
    branch_ids: "2,3",
    class_id: "5",
    subject_id: 503,
    title: "Organic Chemistry Revision: Carbon compounds overview",
    description: "Brief recap of carbon bonds and molecular structures for final examinations review.",
    video_url: "carbon_compounds_revision_r2",
    publish: 0, // Draft status
    doc_file: "Carbon_Compounds_Notes.pdf",
    video_date: "2026-06-03",
    estatus: 1,
    inserted_by: 12,
    inserted_time: "2026-06-03T09:30:00Z",
    updated_by: 12,
    updated_time: "2026-06-03T09:30:00Z",
  }
];
